import { render } from "./UnprocessedDocumentsPage.vue?vue&type=template&id=5bd53f7b&scoped=true"
import script from "./UnprocessedDocumentsPage.vue?vue&type=script&lang=js"
export * from "./UnprocessedDocumentsPage.vue?vue&type=script&lang=js"

import "./UnprocessedDocumentsPage.vue?vue&type=style&index=0&id=5bd53f7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd53f7b"]])

export default __exports__